module.exports = __webpack_public_path__ + "static/lady-getting-vaccine-2acd70d082a5b07e341b5666cad1da2b.jpg";